export const convertEpochToDateFormat = (epochDate) => {

  // if(isEpoch(epochDate)) {
  //     const date = new Date(epochDate); // Convert seconds to milliseconds
  //     console.log("DATE  ", date)
  //     return date.toLocaleString();
  // }
  // return epochDate

  // Check if it's a Unix timestamp
  const date = new Date(epochDate); // Convert seconds to milliseconds
  if (isNaN(date.getTime())) {
    return epochDate;
  }
  return date.toLocaleString();
  // }
  // } else {
  //   // Assuming it's already in the desired format
  //   console.log("EPOCH DATE ", epochDate);
  //   return epochDate;
  // }
};



// const dateObject = convertEpochToDateFormat(response.data[0].due_date)
// console.log("DATE OBJECT ", dateObject)
